import { useState } from 'react';
import KpiStatStrip from './KpiStatStrip';
import CourtroomGrid from  "../main-dahsboard/CourtroomGrid"
import type { Flag } from "../helpers/types"

export default function ControllerDashboard() {
  const [flags, setFlags] = useState<Flag[]>([]);
  const activeFlags = flags.filter(f => !f.rv);
  const activePii = activeFlags.filter(f => f.tp === 'pii').length;
  const activeConductCount = activeFlags.filter(f => f.tp === 'conduct').length;

  return (
    <div className="page min-h-screen flex flex-col px-4 py-3 gap-2">
      <KpiStatStrip
        activePii={activePii}
        activeConductCount={activeConductCount}
        activeFlagCount={activeFlags.length}
      />
      <div id="crSec">
        <CourtroomGrid flags={flags} setFlags={setFlags} />
      </div>
      <div id="archivalSec" />
    </div>
  );
}